import { GET_PROFILE_DETAIL, GET_PROFILE_LIST, GET_PROFILE_DETAIL_PEGAWAI, PUT_PROFILE_ME } from "shared/constants/ActionTypes";

const initialState = {
    profileList: null,
    profileMe: {},
    profileDetail: {}
}

const profileReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PROFILE_LIST:
            return {
                ...state,
                profileList: action.payload
            }
        case GET_PROFILE_DETAIL:
            return {
                ...state,
                profileMe: action.payload
            }
        case GET_PROFILE_DETAIL_PEGAWAI:
            return {
                ...state,
                profileDetail: action.payload
            }
        case PUT_PROFILE_ME:
            return {
                ...state,
            }
        default:
            return {
                ...state
            }
    }
};

export default profileReducer;